import React, {useState} from 'react';
import {Button} from "./Button";
import {PageLoader} from "./Loader";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {fetchUserAlbums, USER_ALBUMS_KEY} from "../../api/public-voissa/users";
import {toastError, toastSuccess} from "../../libs/toast";
import {MEDIA} from "../../const/toasts";
import {MEDIA_KEY, moveMedia} from "../../api/public-voissa/medias";
import {ALBUM_MEDIAS_KEY} from "../../api/public-voissa/albums";

const MoveMedia = ({
       handleClose = () =>{},
       activeAlbumId = null,
       userId = null,
       mediaId = null
    }) =>{
    const queryClient = useQueryClient();
    const [albumIdSelected, setAlbumIdSelected] = useState(activeAlbumId);

    const {isSuccess : isSuccessAlbums, data : dataAlbums, isFetched : isFetchedAlbums} = useQuery(
        [USER_ALBUMS_KEY, userId, {limit : false}],
        ()=> fetchUserAlbums(userId, {limit : false}),
        {
            staleTime : (1000 * 60 * 5),
            enabled : !!userId && !!mediaId,
            placeholderData : [],
            select : data => data.data || []
        }
    );

    const {
        isLoading : isLoadingMoveMedia,
        mutate : mutateMoveMedia,
    } = useMutation((data) => moveMedia(mediaId, data),{
        onSuccess: async (data, variables) =>{
            //todo: penser a invalide le media en cour
            await queryClient.invalidateQueries([ALBUM_MEDIAS_KEY, activeAlbumId]);
            await queryClient.invalidateQueries([ALBUM_MEDIAS_KEY, variables.album]);
            await queryClient.invalidateQueries([USER_ALBUMS_KEY, userId]);
            await queryClient.invalidateQueries([MEDIA_KEY, mediaId]);
            handleClose();
            toastSuccess(MEDIA.SUCCESS.MOVE);
        },
        onError: () =>{
            toastError(MEDIA.ERROR.MOVE);
        }
    });

    let albums = dataAlbums || [];

    return !isSuccessAlbums ? (
        <div id="shift" className={"modal-container"}>
            <PageLoader/>
        </div>
    ) : (
        <div id="shift" className={"modal-container"}>
            <div className={"modal-topline"}>
                <div className="head-title border-bottom">Déplacer votre media</div>
            </div>
            <div className={"modal-body"}>
                {!isFetchedAlbums ? <PageLoader/> : (
                    <select className="full" onChange={(event) => setAlbumIdSelected(event.target.value)}
                            value={albumIdSelected}>
                        <option disabled value="0">Déplacer vers :</option>
                        {albums.map((item) =>
                            <option key={item._id} value={item._id}>{item.title}</option>)}
                    </select>
                )}
            </div>
            <div className={"modal-baseline"}>
                <Button size={"small"}
                        btnStyle={"grey"}
                        onClick={() => handleClose()}
                        content={"Annuler"}/>
                <Button size={"small"}
                        btnStyle={"primary-reverse"}
                        disabled={isLoadingMoveMedia}
                        loading={isLoadingMoveMedia}
                        onClick={() => !isLoadingMoveMedia ? mutateMoveMedia({album : albumIdSelected}) : null}
                        content={"Valider"}/>
            </div>
        </div>
    )
};

export default MoveMedia;